import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { trackPageView } from "~/integrations/posthog/client";

export const usePostHogPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    trackPageView(location.pathname);
  }, [location.pathname]);
};
